import React, { useEffect, useImperativeHandle } from 'react';
import './Modal.scss';
import PropTypes from 'prop-types';

const Modal = React.forwardRef((props,ref) => {
    const [ visible, setVisible ] = React.useState(false)//모달 렌더링 여부
    const [ startTaget, setStartTarget ] = React.useState('')//backdrop target check

    useImperativeHandle( ref, () => ({
        closeModal: () => {
            closeModal()
        },
        openModal: () => {
            openModal()
        }
    }))

    useEffect(() => {
        setVisible(props.visible)
    },[props.visible])

    const closeModal = () => {
        document.body.style.overflow = 'unset';
        setVisible(false)
    }

    const openModal = () => {
        document.body.style.overflow = 'hidden';
        setVisible(true)
    }

    const onBackdropClick = (e) => {
        if(e.target.id === 'wrapper' && startTaget === 'wrapper') {
            if( typeof props.onBackdropClick !== 'undefined'){
                if(props.onBackdropClick === null )return
                props.onBackdropClick();
            }
            else closeModal()
        }
    }

    if( !visible ) return null
    else{
        return (
            <div className='modal'>
                <div id="wrapper" className='modal-wrapper' onMouseDown={(e) => setStartTarget(e.target.id)} onMouseUp={(e) => onBackdropClick(e)}>
                    <div id="content" className='modal-content' style={props.contentContainer}>
                        {props.isHeader &&
                            <div className='modal-header' style={{ marginBottom : 40 }}>
                                <p className='header-title'>{props.title}</p>
                                <div onClick={() => closeModal()} style={{ cursor : 'pointer'}}>
                                    <img src={require('../../aseets/icons/close.svg').default} style={{ width : 31, height : 31,cursor : 'pointer' }} />
                                </div>
                            </div>
                        }
                        {props.children}
                    </div>
                </div>
            </div>
        )
    }
})

Modal.propTypes = {
    children : PropTypes.element,
    onBackdropClick : PropTypes.func
}

export default Modal;